import { graphql } from 'relay-runtime';

export const getUnitByIdAlt = graphql`
  query SingleUnitGetTargetWithLessonsQuery($targetId: ID!) {
    target(targetId: $targetId) {
      id
      name
      summary
      isActive
      targetGroup {
        name
      }
      targetSkills {
        id
        isActive
        targetSkillType {
          id
          name
        }
        skill {
          id
          name
          code
          difficulty
          skillAncestries {
            id
            ancestorSkill {
              id
              name
              code
              difficulty
            }
            skillRelevance {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const getUnitById = graphql`
  query SingleUnitGetTargetQuery($targetId: ID!, $targetGroupIsActive: ActiveRecords = BOTH) {
    target(targetId: $targetId, filter: { isActive: ACTIVE }, targetGroupFilter: { isActive: $targetGroupIsActive }) {
      id
      name
      summary
      isActive
      targetGroup {
        name
      }
      targetSkills {
        id
        isActive
        targetSkillType {
          id
          name
        }
        skill {
          id
          name
          code
          difficulty
          lessons(filter: { lessonTypeIds: ["LessonTypeNode:11"], isActive: true }) {
            id
          }
          skillAncestries {
            id
            ancestorSkill {
              id
              name
              code
              difficulty
            }
            skillRelevance {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const getSkillProgress = graphql`
  query SingleUnitSkillProgressQuery($classIds: [ID!]!, $targetIds: [ID!]!) {
    skillProgress(classIds: $classIds, targetIds: $targetIds) {
      skill {
        id
        name
      }
      usersBySkillResults {
        key
        value {
          id
          firstName
          lastName
          publicUserId
        }
      }
    }
  }
`;

export const getCurriculumLessons = graphql`
  query SingleUnitGetCurriculumLessonsQuery($filter: CurriculumLessonsFilterInput, $skip: Boolean!) {
    curriculumLessons(filter: $filter) @skip(if: $skip) {
      id
      number
      name
      skills {
        id
      }
    }
  }
`;

export const getTargetStudentIsWorkingOn = graphql`
  query SingleUnitTargetStudentIsWorkingOnQuery($userId: ID!) {
    getTargetStudentIsWorkingOn(userId: $userId) {
      id
      name
      summary
    }
  }
`;
